import { render } from "./EventDeleteDialog.vue?vue&type=template&id=b666fc58"
import script from "./EventDeleteDialog.vue?vue&type=script&lang=js"
export * from "./EventDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__